import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { apiUrl } from '../utils/apiBase';
import { pluralPL } from '../utils/pluralPL';

interface ClubItem {
  id: number;
  slug: string;
  name: string;
  tournamentCount: number;
  leagueCount: number;
}

const ClubsList: React.FC = () => {
  const [clubs, setClubs] = useState<ClubItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetch(apiUrl('/api/public/clubs'))
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        return res.json() as Promise<{ items: ClubItem[] }>;
      })
      .then((data) => {
        setClubs(data.items);
        setLoading(false);
      })
      .catch(() => {
        setError('Nie udało się załadować klubów.');
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="events-loading">Ładowanie...</div>;
  }

  if (error) {
    return <div className="events-error">{error}</div>;
  }

  return (
    <div className="events-list">
      <div className="events-list-header">
        <div>
          <span className="eyebrow">Organizatorzy</span>
          <h1>Kluby</h1>
        </div>
      </div>

      {clubs.length === 0 ? (
        <p className="events-empty">Brak klubów do wyświetlenia.</p>
      ) : (
        <ul className="events-cards">
          {clubs.map((club) => (
            <li key={club.id} className="event-card">
              <h2 className="event-card-name">{club.name}</h2>
              <div className="event-card-meta">
                <span className="event-card-dates">
                  {club.leagueCount} {pluralPL(club.leagueCount, 'liga', 'ligi', 'lig')}
                </span>
                <span className="event-card-dates">
                  {club.tournamentCount} {pluralPL(club.tournamentCount, 'turniej', 'turnieje', 'turniejów')}
                </span>
              </div>
              <Link to={`/clubs/${club.slug}`} className="event-card-link">
                Otwórz klub
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ClubsList;
